module.exports = __webpack_public_path__ + "img/racecourse-durbanville-turf-1600.e255fd8b.svg";